<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Print Preview · Wide Dialog</title>
  <!-- Tailwind via CDN -->
  <script src="https://cdn.tailwindcss.com"></script>
  <!-- Material Icons -->
  <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
  <style>
    body {
      background: linear-gradient(145deg, #eef2f6 0%, #f8fafc 100%);
      font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    }
    
    .preview-dialog {
      box-shadow: 0 25px 40px -12px rgba(0,20,30,0.25);
      border: 1px solid rgba(255,255,255,0.3);
    }
    
    /* Hide scrollbar for PDF viewer */
    .hide-scrollbar::-webkit-scrollbar {
      display: none;
    }
    .hide-scrollbar {
      -ms-overflow-style: none;
      scrollbar-width: none;
    }
    
    /* Button hover effects */
    .btn-hover {
      transition: all 0.2s ease;
    }
    .btn-hover:hover {
      transform: translateY(-2px);
      box-shadow: 0 12px 20px -8px rgba(0,47,73,0.2);
    }
    
    /* Ensure footer is always sticky at bottom */
    .sticky-footer {
      position: sticky;
      bottom: 0;
      z-index: 10;
    }
  </style>
</head>
<body class="flex items-center justify-center min-h-screen p-6 antialiased">
  <!-- DIALOG - WIDER WIDTH: max-w-6xl for large screens, 95% on mobile -->
  <div 
    class="preview-dialog w-full max-w-7xl rounded-2xl bg-white overflow-hidden flex flex-col"
    style="height: 85vh; min-height: 650px; max-height: 950px; width: 95%;"
  >
    <!-- === TITLE BAR - Fixed at top === -->
    <div class="flex items-center justify-between px-8 py-5 bg-white border-b border-gray-100 sticky top-0 z-10">
      <div class="flex items-center gap-4">
        <button 
          (click)="onCloseDialog()"
          class="flex items-center justify-center w-10 h-10 rounded-lg bg-[#263238] hover:bg-[#1a262a] transition-colors shadow-sm"
          aria-label="Close preview"
        >
          <span class="material-icons text-white text-2xl">highlight_off</span>
        </button>
        <h2 class="text-xl font-semibold text-gray-800">Print Preview</h2>
      </div>
      <div class="flex items-center gap-3">
        <span class="text-xs text-gray-500 bg-gray-100 px-4 py-2 rounded-full">PDF • Letter size</span>
        <span class="text-xs text-gray-500 bg-gray-100 px-4 py-2 rounded-full">1 page</span>
      </div>
    </div>

    <!-- === PREVIEW BODY - Takes remaining space, scrollable if needed === -->
    <div class="flex-1 p-6 bg-gray-50/80 overflow-auto">
      <div class="w-full h-full min-h-[550px] rounded-xl bg-white border border-gray-200 shadow-inner overflow-hidden">
        <object
          #pdfViewer
          type="application/pdf"
          class="w-full h-full hide-scrollbar"
          style="min-height: 550px;"
        ></object>
      </div>
      <!-- PDF info bar -->
      <!-- <div class="flex justify-between items-center mt-4 text-xs text-gray-400">
        <div class="flex items-center gap-2">
          <span class="material-icons text-base text-gray-300">description</span>
          <span>sample_document.pdf • 245 KB</span>
        </div>
        <div class="flex items-center gap-2">
          <span class="material-icons text-base text-gray-300">schedule</span>
          <span>Last modified: Today, 2:30 PM</span>
        </div>
      </div> -->
    </div>

    <!-- === STICKY FOOTER - ALWAYS VISIBLE with wider spacing === -->
    <div class="sticky-footer bg-white border-t border-gray-200 px-8 py-5 flex items-center justify-between shadow-lg">
      <!-- DOWNLOAD button - Left side -->
      <button 
        (click)="downloadPdf()"
        class="btn-hover inline-flex items-center justify-center gap-3 px-6 py-3 rounded-lg bg-gray-50 hover:bg-gray-100 text-gray-700 font-medium text-sm border border-gray-300 hover:border-gray-400 transition-all"
      >
        <span class="material-icons text-gray-600 text-xl">save_alt</span>
        <span>DOWNLOAD PDF</span>
      </button>
      
      <!-- Center indicator - Optional decorative element -->
      <div class="hidden md:flex items-center gap-3 text-xs text-gray-400">
        <span class="material-icons text-base">remove_red_eye</span>
        <span>Ready for print</span>
      </div>
      
      <!-- PRINT button - Right side, Primary action -->
      <button 
        (click)="print()"
        class="btn-hover inline-flex items-center justify-center gap-3 px-8 py-3 rounded-lg bg-[#263238] hover:bg-[#1a262a] text-white font-medium text-base shadow-md hover:shadow-lg transition-all"
      >
        <span class="material-icons text-white/90 text-xl">print</span>
        <span>PRINT</span>
      </button>
    </div>
  </div>
</body>
</html>